<div class="cmms-applied-filters-bar">
	<div class="search-bar-container">
		<search-bar />
	</div>
	<div class="filters-bar-actions">
		<button mat-stroked-button [matMenuTriggerFor]="filtersList">
			<mat-icon svgIcon="filter"></mat-icon>
			<p class="label horizontal">Filter</p>
		</button>
		@if (selectedFilters.length) {
			<div class="clear" (click)="clearFilters()">
				<span>{{ 'clear' | translate }}</span>
			</div>
		}
	</div>
</div>

<mat-menu #filtersList="matMenu" class="cmms-filter-menu" yPosition="below">
	<filter-list-menu />
</mat-menu>
